import { Roles } from "features/panelManagement/accessManagement/types/access";

export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";

export enum AuthAction {
    LOGIN_USER = "[AuthAction] LOGIN_USER",
    LOGOUT_USER = "[AuthAction] LOGOUT_USER",
}
interface LoginUser {
    type: AuthAction.LOGIN_USER;
    role: Roles;
    uid: string;
}

interface LogoutUser {
    type: AuthAction.LOGOUT_USER;
}

export type AuthActionTypes = LoginUser | LogoutUser;
